// extracted by mini-css-extract-plugin
module.exports = {"root":"MassDownload_root__2AKS7"};